/**
 * Handles image clicks by opening the image in a new tab on desktop
 * and in the same tab on mobile devices.
 * 
 * @param {string} imageUrl - The URL of the image to open.
 */
export const handleImageClick = (imageUrl) => {
    if (!imageUrl) return;

    // Check if the screen width is less than 768px (common mobile breakpoint)
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
        // Open in same tab for mobile
        window.location.href = imageUrl;
    } else {
        // Open in new tab for desktop
        window.open(imageUrl, '_blank');
    }
};
